import { ActionType, MenuState } from '../../schemas/Menu/Menu.Schema';
import * as Constants from '../../utils/constants';
import produce from 'immer';

export const initialMenuState: MenuState = {
  submitFeedback: []
};

export default (state = initialMenuState, action: ActionType) =>
  produce(state, draft => {
    if (action.type === Constants.GET_SUBMIT_FEEDBACK) {
      draft.submitFeedback = action.payload;
    }
  });
